import { render, staticRenderFns } from "./SurveyUserAdmin.vue?vue&type=template&id=157fa708"
import script from "./SurveyUserAdmin.vue?vue&type=script&lang=js"
export * from "./SurveyUserAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports